import { AppConfig } from '../types/app-config-type.ts';

export function formatOrderId(config: AppConfig, id: string): string {
    const { stripOrderIdPrefix } = config;
    return stripOrderIdPrefix ? id.split('-').at(-1)! : id;
}
